/* FUT7 — página de produto (port da camada tnf-cro.js da TNF v8), sem tocar no main-product.liquid.
   1 escada de oferta abaixo do preço · 2 rótulo do tamanho · 3 botões do guia de tamanhos · 4 linha do tempo de entrega
   5 vitrines (mais versões do clube / também vais gostar) · 6 benefícios em carrossel no telemóvel · 7 barra fixa de compra.
   NÃO mexe na personalização (Nome / Número) nem nos emblemas (Badges): esses blocos são da FUT7 e continuam iguais. */
(function(){
  if (window.__f7Product) return;
  window.__f7Product = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var I18N = {};
  try { var ie = document.getElementById('f7-p-i18n'); if (ie) I18N = JSON.parse(ie.textContent); } catch(e){}
  function _t(k, v){ var s = I18N[k] || k; if (v) { for (var x in v) { s = s.split('{' + x + '}').join(v[x]); } } return s; }
  function esc(s){ return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function el(tag, cls, html){ var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var ICONS = {
    ship: '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/>',
    cart: '<path d="M3 4h2.5l2.2 10.5h10.6L20.5 7H7"/><circle cx="9.5" cy="19" r="1.4"/><circle cx="17" cy="19" r="1.4"/>',
    home: '<path d="M4 11l8-6.5 8 6.5"/><path d="M6 9.5V20h12V9.5"/><path d="M10 20v-5h4v5"/>',
    pin: '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    ruler: '<path d="M3 16.5L16.5 3l4.5 4.5L7.5 21z"/><path d="M7 13l1.5 1.5M10 10l1.5 1.5M13 7l1.5 1.5"/>',
    person: '<circle cx="12" cy="7.5" r="3.5"/><path d="M5 20.5c.6-4 3.3-6.5 7-6.5s6.4 2.5 7 6.5"/>'
  };
  function svg(k){ return '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICONS[k] + '</svg>'; }

  /* Nome do clube pelo código no handle (mapa [data-f7-clubes]; pt: n, outros: ne) */
  var TEAM = null;
  function teamMap(){
    if (TEAM) return TEAM;
    TEAM = {};
    var d = document.querySelector('[data-f7-clubes]');
    var pt = /^pt/i.test(document.documentElement.lang || '');
    try { (d ? JSON.parse(d.textContent) : []).forEach(function(c){ if (c && c.c && !TEAM[c.c]) TEAM[c.c] = pt ? c.n : (c.ne || c.n); }); } catch(e){}
    return TEAM;
  }
  function codeOf(handle){
    var map = teamMap(), parts = (handle || '').split('-');
    for (var i = parts.length - 1; i >= 0; i--) { if (/^[0-9]{3}$/.test(parts[i]) && map[parts[i]]) return parts[i]; }
    return '';
  }

  function addBusinessDays(n){
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }

  function init(){
    var info = document.querySelector('product-info') || document.querySelector('.product__info-container');
    var cfg = document.querySelector('[data-f7-p-cfg]');

    if (info) {
      /* 1. Escada de oferta (bilhetes) logo abaixo do preço */
      var ladder = document.querySelector('[data-f7-p-ladder-src] .f7-p-tix');
      var price = info.querySelector('[id^="price-"]');
      if (ladder && price && price.parentNode) price.parentNode.insertBefore(ladder, price.nextSibling);

      /* 2. Rótulo da opção "Size" no idioma da página (o nome vem do produto) */
      info.querySelectorAll('variant-radios legend, variant-selects label, .product-form__input .form__label').forEach(function(l){
        l.childNodes.forEach(function(n){ if (n.nodeType === 3 && /^\s*Size\s*$/i.test(n.textContent)) n.textContent = n.textContent.replace(/Size/i, _t('size')); });
      });

      /* 3. "Acerta no tamanho": um botão só no lugar dos dois do f7-size-tools (snippets/f7-p-tamanho) */
      fitTool();

      /* 3b. Bandeiras de pagamento logo abaixo do botão de compra */
      var payBox = document.querySelector('[data-f7-p-pay-src] .f7-p-pay');
      var buyBtns = info.querySelector('product-form');
      var payAnchor = buyBtns && (buyBtns.closest('.product-form__buttons') || buyBtns.closest('[id^="Product-"]') || buyBtns);
      if (payBox && payAnchor && payAnchor.parentNode) payAnchor.parentNode.insertBefore(payBox, payAnchor.nextSibling);

      /* 3c. Tamanho obrigatório: sem ?variant= na URL, nenhum tamanho aparece marcado e o botão pede a escolha */
      if (cfg && cfg.dataset.requireSize === 'true') sizeGuard(info);

      /* 4. Entrega: linha do tempo Encomenda → Envio → Chegada, com os prazos do país (snippets/f7-mercados) */
      var buy = info.querySelector('product-form');
      var anchor = buy && (buy.closest('.product-form__buttons') || buy.closest('[id^="Product-"]') || buy);
      if (cfg && anchor && !info.querySelector('.f7-p-eta')) {
        var min = parseInt(cfg.dataset.min, 10) || 5, max = parseInt(cfg.dataset.max, 10) || 15;
        var avg = Math.round((min + max) / 2);
        var lang = document.documentElement.lang || 'pt-PT';
        var d1 = addBusinessDays(min), d2 = addBusinessDays(max);
        var md = {month: 'short', day: 'numeric'};
        var range = d1.getMonth() === d2.getMonth()
          ? d1.toLocaleDateString(lang, {day: 'numeric'}) + '–' + d2.toLocaleDateString(lang, md)
          : d1.toLocaleDateString(lang, md) + ' – ' + d2.toLocaleDateString(lang, md);
        var country = cfg.dataset.country || '';
        var carrier = cfg.dataset.carrier || '';
        /* v5: mesma ideia (hoje → envio → em casa), visual novo: data grande, régua de progresso e país */
        var eta = el('div', 'f7-p-eta2');
        eta.setAttribute('role', 'group');
        eta.setAttribute('aria-label', _t('estimate'));
        eta.innerHTML =
          '<div class="f7-p-eta2__top"><span class="f7-p-eta2__ico">' + svg('ship') + '</span><div><b class="f7-p-eta2__t"></b><span class="f7-p-eta2__s"></span></div></div>' +
          '<div class="f7-p-eta2__track" aria-hidden="true"><i class="f7-p-eta2__fill"></i><span class="is-on"></span><span class="is-on"></span><span></span></div>' +
          '<div class="f7-p-eta2__steps"><span class="is-on"></span><span></span><span></span></div>';
        eta.querySelector('.f7-p-eta2__t').textContent = _t('eta_title', {range: range});
        eta.querySelector('.f7-p-eta2__s').textContent = _t('eta_sub', {country: country, n: avg, min: min, max: max});
        var st = eta.querySelectorAll('.f7-p-eta2__steps span');
        st[0].textContent = _t('eta_today'); st[1].textContent = _t('eta_ship'); st[2].textContent = _t('eta_home');
        var afterPay = payBox && payBox.parentNode === anchor.parentNode ? payBox : anchor;
        anchor.parentNode.insertBefore(eta, afterPay.nextSibling);
      }
    }

    /* 5. Vitrines */
    document.querySelectorAll('[data-f7-p-rail]').forEach(loadRail);
    /* 6. Benefícios em carrossel automático no telemóvel */
    document.querySelectorAll('.f7-p-benefits__grid').forEach(benefitsCarousel);

    /* 7. Barra de compra flutuante: aparece quando o botão de compra sai da tela; o clique aciona o botão original
          (é ele que leva Nome, Número e Badges no formulário). */
    var bar = document.querySelector('[data-f7-p-sticky]');
    var getBtn = function(){ return (info && info.querySelector('product-form button[type=submit]')) || document.querySelector('product-form button[type=submit]'); };
    if (bar && getBtn()) {
      var tEl = bar.querySelector('[data-f7-p-sticky-title]'), pEl = bar.querySelector('[data-f7-p-sticky-price]');
      var sEl = bar.querySelector('[data-f7-p-sticky-size]'), btn = bar.querySelector('[data-f7-p-sticky-btn]');
      var sync = function(){
        var h1 = document.querySelector('.product__title h1');
        if (h1) tEl.textContent = h1.textContent.trim();
        if (!info) return;
        var items = Array.prototype.filter.call(info.querySelectorAll('[id^="price-"] .price-item'), function(x){ return x.offsetParent !== null && x.textContent.trim() && x.tagName !== 'S'; });
        if (items.length) pEl.textContent = items[items.length - 1].textContent.trim();
        var size = info.querySelector('variant-radios input:checked, variant-selects select');
        sEl.textContent = size && size.value ? _t('size_value', {size: size.value}) : '';
      };
      var ticking = false;
      var typing = function(){
        var a = document.activeElement;
        if (a && (a.tagName === 'TEXTAREA' || a.tagName === 'SELECT' || (a.tagName === 'INPUT' && !/^(radio|checkbox|button|submit|range|color|file|hidden|image|reset)$/i.test(a.type || '')))) return true;
        var vv = window.visualViewport;
        return !!(vv && vv.height < window.innerHeight * 0.75);
      };
      var check = function(){
        ticking = false;
        var r = getBtn().getBoundingClientRect();
        /* v6 (24/10): com o teclado aberto (a escrever o nome/número ou noutro campo) a barra não entra, senão tapa o ecrã */
        var show = !typing() && window.scrollY > 200 && (r.bottom < 0 || r.top > window.innerHeight);
        if (show === bar.classList.contains('is-visible')) return;
        if (show) sync();
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        btn.tabIndex = show ? 0 : -1;
      };
      var onScroll = function(){ if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll);
      document.addEventListener('focusin', onScroll);
      document.addEventListener('focusout', function(){ setTimeout(onScroll, 120); });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', onScroll);
      check();
      btn.addEventListener('click', function(){
        var b = getBtn();
        if (b.disabled) { b.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'}); return; }
        b.click();
      });
    }
  }

  function sizeGuard(info){
    if (/[?&]variant=/.test(location.search)) return;
    var fs = null;
    info.querySelectorAll('variant-radios fieldset').forEach(function(f){
      var lg = f.querySelector('legend');
      var t = lg ? lg.textContent : '';
      if (!fs && /size|tamanho|talla|taille|größe|taglia|maat/i.test(t)) fs = f;
    });
    if (!fs || fs.querySelectorAll('input[type=radio]').length < 2) return;
    var chosen = false, msg = null;
    fs.classList.add('f7-p-pick');
    /* A legenda "Tamanho | S" mostra o S pré-escolhido: fica escondido até o cliente escolher */
    var lg = fs.querySelector('legend');
    if (lg) Array.prototype.slice.call(lg.childNodes).forEach(function(n){
      if (n.nodeType === 3 && n.textContent.trim() && n.previousSibling && n.previousSibling.nodeType === 1) { var w = el('span', 'f7-p-selv'); w.textContent = n.textContent; lg.replaceChild(w, n); }
    });
    var done = function(){ if (chosen) return; chosen = true; fs.classList.remove('f7-p-pick', 'f7-p-pick--err'); if (msg) msg.hidden = true; };
    fs.addEventListener('click', function(e){ if (e.target.closest('label, input')) done(); });
    fs.addEventListener('change', done);
    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('product-form button[type=submit], product-form [name="add"]');
      if (!b || chosen) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!msg) { msg = el('p', 'f7-p-pick__msg'); msg.setAttribute('role', 'alert'); fs.appendChild(msg); }
      msg.textContent = _t('pick_size'); msg.hidden = false;
      fs.classList.remove('f7-p-pick--err'); void fs.offsetWidth; fs.classList.add('f7-p-pick--err');
      fs.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'});
    }, true);
  }

  /* Medidas = as mesmas da tabela do f7-size-tools: [tamanho, altura mín, altura máx, largura, comprimento, peso mín, peso máx] */
  var FIT = [['S', 162, 170, 50, 72, 50, 62], ['M', 170, 176, 52, 74, 62, 78], ['L', 176, 182, 54, 76, 78, 83],
             ['XL', 182, 190, 56, 78, 83, 90], ['2XL', 190, 195, 58, 80, 90, 97], ['3XL', 195, 200, 60, 82, 97, 104]];

  /* Silhueta da camisola em SVG: w = largura de axila a axila (cm), l = comprimento (cm) */
  function shirtPath(w, l){
    var hw = w * 0.9, L = l * 1.75, c = 100, top = 10, arm = 46, hem = top + L;
    var p = [[c - 14, top], [c - hw + 4, 16], [c - hw - 26, 44], [c - hw - 14, 58], [c - hw, arm], [c - hw, hem],
             [c + hw, hem], [c + hw, arm], [c + hw + 14, 58], [c + hw + 26, 44], [c + hw - 4, 16], [c + 14, top]];
    return 'M' + p.map(function(x){ return x[0].toFixed(1) + ' ' + x[1].toFixed(1); }).join('L') + 'Q' + c + ' ' + (top + 14) + ' ' + (c - 14) + ' ' + top + 'Z';
  }

  function fitTool(){
    var dlg = document.querySelector('[data-f7-p-fit]'), tpl = document.querySelector('template[data-f7-p-fit-tpl]');
    var wrap = document.querySelector('[data-f7-st]');
    if (!dlg || !tpl || !wrap || !dlg.showModal) return;
    var st = wrap.querySelector('.f7-st');
    if (!st || wrap.querySelector('[data-f7-p-fit-open]')) return;
    var T = {};
    try { T = JSON.parse(document.querySelector('[data-f7-p-fit-i18n]').textContent); } catch(e){}
    function f(s, v){ s = s || ''; for (var x in v) s = s.split('{' + x + '}').join(v[x]); return s; }
    /* o botão entra dentro do wrapper do f7-size-tools, que se reancora sozinho quando o tema redesenha os tamanhos */
    st.classList.add('f7-p-fit-on');
    wrap.insertBefore(tpl.content.cloneNode(true), st);
    if (dlg.parentNode !== document.body) document.body.appendChild(dlg);

    var w = dlg.querySelector('#f7-p-fit-w'), h = dlg.querySelector('#f7-p-fit-h'), k = dlg.querySelector('#f7-p-fit-k');
    var ours = dlg.querySelector('[data-ours]'), yours = dlg.querySelector('[data-yours]'), vtext = dlg.querySelector('[data-vtext]');
    var sizeEl = dlg.querySelector('[data-size]'), why = dlg.querySelector('[data-why]'), pick = dlg.querySelector('[data-f7-p-fit-pick]');
    var mode = 'shirt', cur = null;

    function radioFor(size){
      var ins = document.querySelectorAll('product-info variant-radios input[type=radio], variant-radios input[type=radio]');
      for (var i = 0; i < ins.length; i++) { if (String(ins[i].value).trim().toUpperCase() === size) return ins[i]; }
      return null;
    }
    function soldOut(r){ return !r || r.disabled || r.classList.contains('disabled'); }
    function calc(){
      var idx;
      if (mode === 'shirt') {
        var wv = +w.value, best = 0;
        FIT.forEach(function(s, i){ if (Math.abs(s[3] - wv) < Math.abs(FIT[best][3] - wv)) best = i; });
        idx = best;
      } else {
        var hv = +h.value, kv = +k.value, hi = FIT.length - 1, ki = FIT.length - 1;
        for (var i = 0; i < FIT.length; i++) { if (hv <= FIT[i][2]) { hi = i; break; } }
        for (var j = 0; j < FIT.length; j++) { if (kv <= FIT[j][6]) { ki = j; break; } }
        idx = Math.max(hi, ki);
      }
      /* só tamanhos que existem neste produto: se o recomendado não existe, o mais próximo acima (ou abaixo) */
      var has = FIT.map(function(s){ return !!radioFor(s[0]); });
      if (has.some(Boolean) && !has[idx]) {
        var up = idx; while (up < FIT.length && !has[up]) up++;
        if (up < FIT.length) idx = up; else { while (idx > 0 && !has[idx]) idx--; }
      }
      var s = FIT[idx];
      cur = s[0];
      dlg.querySelector('[data-wout]').textContent = w.value + ' cm';
      dlg.querySelector('[data-hout]').textContent = h.value + ' cm';
      dlg.querySelector('[data-kout]').textContent = k.value + ' kg';
      ours.setAttribute('d', shirtPath(s[3], s[4]));
      yours.setAttribute('d', mode === 'shirt' ? shirtPath(+w.value, s[4]) : '');
      vtext.textContent = mode === 'shirt' ? f(T.yours, {w: w.value, size: s[0], sw: s[3]}) : s[0] + ' · ' + s[3] + ' × ' + s[4] + ' cm';
      sizeEl.textContent = s[0];
      why.innerHTML = esc(mode === 'shirt' ? f(T.why_shirt, {w: w.value, size: s[0], sw: s[3], sl: s[4]}) : f(T.why_body, {h: h.value, k: k.value, size: s[0]}))
        .replace(new RegExp('\\b' + s[0] + '\\b'), '<b>' + s[0] + '</b>');
      var r = radioFor(s[0]), off = soldOut(r);
      pick.textContent = f(off ? T.sold : T.pick, {size: s[0]});
      pick.disabled = off;
    }
    dlg.querySelectorAll('[role=tab]').forEach(function(tab){
      tab.addEventListener('click', function(){
        mode = tab.dataset.t;
        dlg.querySelectorAll('[role=tab]').forEach(function(x){ x.setAttribute('aria-selected', x === tab ? 'true' : 'false'); });
        dlg.querySelectorAll('[data-p]').forEach(function(p){ p.hidden = p.dataset.p !== mode; });
        calc();
      });
    });
    [w, h, k].forEach(function(i){ i.addEventListener('input', calc); });
    document.addEventListener('click', function(e){
      if (e.target.closest('[data-f7-p-fit-open]')) { calc(); dlg.showModal(); }
    });
    dlg.querySelector('[data-f7-p-fit-close]').addEventListener('click', function(){ dlg.close(); });
    dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
    pick.addEventListener('click', function(){
      var r = radioFor(cur);
      if (soldOut(r)) return;
      var lab = r.id && document.querySelector('label[for="' + r.id + '"]');
      (lab || r).click();
      dlg.close();
    });
    dlg.querySelector('[data-f7-p-fit-table]').addEventListener('click', function(){
      dlg.close();
      var g = document.querySelector('[data-f7-st] [data-f7-open="guide"]');
      if (g) g.click();
    });
  }

  /* Chips da vitrine "Mais versões": [categoria do card, chave do texto] */
  var CATS = [['all', 'all'], ['fan', 'fan'], ['player', 'player'], ['women', 'women'], ['kids', 'kids'], ['long', 'long_sleeve'], ['training', 'training']];

  function loadRail(rail){
    var mode = rail.dataset.mode, track = rail.querySelector('[data-f7-p-rail-track]');
    var code = rail.dataset.code, url;
    if (mode === 'versions') {
      if (!code) { rail.hidden = true; return; }
      url = ROOT + 'collections/' + code + '?section_id=f7-p-feed';
    } else {
      url = ROOT + 'recommendations/products?product_id=' + rail.dataset.productId + '&limit=16&section_id=f7-p-feed';
    }
    fetch(url, {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.text() : ''; }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var feed = doc.querySelector('.f7-p-feed');
      var seen = {};
      var map = teamMap();
      var cards = Array.prototype.filter.call(doc.querySelectorAll('.f7-h-pcard'), function(c){
        var h = c.dataset.handle;
        if (!h || seen[h] || h === rail.dataset.handle) return false;
        if (mode !== 'versions' && code && c.dataset.code === code) return false;
        seen[h] = 1; return true;
      }).slice(0, 12);
      if (!cards.length) { rail.hidden = true; return; }
      track.innerHTML = '';
      cards.forEach(function(c){
        var node = document.importNode(c, true);
        var t = node.querySelector('.f7-h-pcard__title');
        var club = map[node.dataset.code] || map[codeOf(node.dataset.handle)];
        if (t && club && t.textContent.indexOf(club) === -1) t.textContent = club + ' ' + t.textContent.trim();
        track.appendChild(node);
      });
      if (mode === 'versions') {
        var club = map[code];
        var title = rail.querySelector('[data-f7-p-rail-title]');
        if (club && title && title.dataset.clubTitle) title.innerHTML = esc(title.dataset.clubTitle).replace('[club]', '<span>' + esc(club) + '</span>');
        buildChips(rail, track);
        viewAll(rail, track, code, club, parseInt(feed && feed.dataset.total, 10) || 0, cards.length);
      }
      wireNav(rail, track);
    }).catch(function(){ rail.hidden = true; });
  }

  /* "Ver todos": botão no topo + cartão no fim da vitrine (na FUT7 a coleção do clube é /collections/<código>) */
  function viewAll(rail, track, code, club, total, shown){
    var link = rail.querySelector('[data-f7-p-all]');
    var href = ROOT + 'collections/' + code;
    var tile = el('a', 'f7-h-pcard--more', '<b></b><span>' + esc(_t('shop_collection')) + ' ' + svg('arrow') + '</span>');
    tile.querySelector('b').textContent = club ? _t('all_club_items', {club: club}) : _t('see_full_collection');
    tile.href = href;
    track.appendChild(tile);
    if (link) { link.querySelector('span').textContent = total > shown ? _t('view_all_count', {count: total}) : _t('view_collection'); link.href = href; link.hidden = false; }
  }

  function buildChips(rail, track){
    var wrap = rail.querySelector('[data-f7-p-rail-chips]');
    if (!wrap) return;
    var cards = track.querySelectorAll('.f7-h-pcard');
    var counts = {all: cards.length};
    cards.forEach(function(c){ (c.dataset.cats || '').split(' ').forEach(function(k){ if (k) counts[k] = (counts[k] || 0) + 1; }); });
    var present = CATS.filter(function(c){ return counts[c[0]]; });
    if (present.length < 3) return;
    present.forEach(function(c, i){
      var b = el('button', 'f7-h-chip' + (i === 0 ? ' is-active' : ''), esc(_t(c[1])) + '<span>' + counts[c[0]] + '</span>');
      b.type = 'button';
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function(){
        wrap.querySelectorAll('.f7-h-chip').forEach(function(x){ x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
        cards.forEach(function(card){ card.hidden = c[0] !== 'all' && (' ' + (card.dataset.cats || '') + ' ').indexOf(' ' + c[0] + ' ') === -1; });
        track.scrollLeft = 0;
        track.dispatchEvent(new Event('scroll'));
      });
      wrap.appendChild(b);
    });
    wrap.hidden = false;
  }

  function wireNav(box, track){
    var prev = box.querySelector('[data-f7-p-prev]'), next = box.querySelector('[data-f7-p-next]');
    if (!prev || !next || prev.dataset.wired) return;
    prev.dataset.wired = '1';
    var step = function(dir){ track.scrollBy({left: dir * track.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth'}); };
    prev.addEventListener('click', function(){ step(-1); });
    next.addEventListener('click', function(){ step(1); });
    var upd = function(){
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    track.addEventListener('scroll', upd, {passive: true});
    window.addEventListener('resize', upd);
    upd();
  }

  function benefitsCarousel(grid){
    var cards = grid.children;
    if (cards.length < 2) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var dots = el('div', 'f7-p-dots');
    var idx = 0, paused = 0, inView = false;
    Array.prototype.forEach.call(cards, function(c, i){
      var b = el('button');
      b.type = 'button';
      b.setAttribute('aria-label', _t('show_benefit', {n: i + 1}));
      b.addEventListener('click', function(){ go(i); paused = Date.now() + 8000; });
      dots.appendChild(b);
    });
    grid.parentNode.insertBefore(dots, grid.nextSibling);
    var stepW = function(){ return cards[1].offsetLeft - cards[0].offsetLeft || grid.clientWidth; };
    function mark(){ Array.prototype.forEach.call(dots.children, function(b, i){ b.classList.toggle('is-active', i === idx); }); }
    function go(i){ idx = i; grid.scrollTo({left: stepW() * i, behavior: reduce ? 'auto' : 'smooth'}); mark(); }
    grid.addEventListener('scroll', function(){ var i = Math.round(grid.scrollLeft / stepW()); if (i !== idx) { idx = Math.max(0, Math.min(cards.length - 1, i)); mark(); } }, {passive: true});
    ['pointerdown', 'touchstart', 'wheel'].forEach(function(ev){ grid.addEventListener(ev, function(){ paused = Date.now() + 8000; }, {passive: true}); });
    if (hasIO) new IntersectionObserver(function(es){ inView = es[0].isIntersecting; }, {threshold: 0.5}).observe(grid);
    mark();
    if (reduce) return;
    setInterval(function(){
      if (!mq.matches || !inView || Date.now() < paused || document.hidden) return;
      go((idx + 1) % cards.length);
    }, 3800);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
